var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"py-4"},[_c('b-row',[_c('b-col',[_c('FCPLogsTable',{attrs:{"fitTableBodyToWindow":true}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }